import {IUnlockChoiceOption, IUnlockChoiceReservationOption} from "../types/IUnlockChoiceOption";

export const isUnlockChoiceReservationOption = (option: IUnlockChoiceOption): option is IUnlockChoiceReservationOption => option.id === "reservation";
import {IUnlockChoiceOption, IUnlockChoiceReservationOption} from "../types/IUnlockChoiceOption";

export const isUnlockChoiceReservationOption = (option: IUnlockChoiceOption): option is IUnlockChoiceReservationOption => option.id === "reservation";
